import React from "react" ;

import AppSidebarMenuItem from "../../Common/Sidebar/AppSidebarMenuItem";
import AppSidebarGroup from "../../Common/Sidebar/AppSidebarGroup";
import {getSafeguardingRouterLink, getUsersRouterLink} from "root/Wieldy/routePaths";
import ScrollRails from "root/Wieldy/ApplicationModules/Common/Body/ScrollRails";
import AppSidebarHeader from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarHeader";
import WieldySidebarSection from "root/Wieldy/Sidebar/WieldySidebarSection";
import WieldySidebarClick from "root/Wieldy/Sidebar/WieldySidebarClick";
import {UserTypeFilters} from "root/DataFunctions/Constants";

const SafeguardingAppSidebar= (props) =>
{
    return (
        <div className="dt-module__sidebar">

            <AppSidebarHeader iconName={props.iconName} title={props.title} />

            <div className="dt-module__sidebar-content ps-custom-scrollbar ps" style={{height: props.height}}>

                <ul className="dt-module-side-nav">

                    <AppSidebarGroup title='View' default='safeguarding'>
                        <AppSidebarMenuItem link={getSafeguardingRouterLink('misuse')} title='Misuse Reports' iconName='icon-files' name='misuse' />
                        <AppSidebarMenuItem link={getSafeguardingRouterLink( UserTypeFilters.BLOCKED)} title='Blocked Users' iconName='icon-user-o' name={UserTypeFilters.BLOCKED} />

                        {/*<WieldySidebarSection title='New Misuse report' >
                            <WieldySidebarClick modal={(event) => clickHandler(event)} title='Resource' iconName='icon-add-circle' iconSize='icon-xl' keyName='root1' key='c1'/>
                        </WieldySidebarSection>*/}
                    </AppSidebarGroup>

                </ul>

                <ScrollRails />

            </div>

        </div>
    ) ;
}

export default SafeguardingAppSidebar;
